import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/mission", label: "Our Mission" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center">
          <Logo height={36} />
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `text-sm tracking-[0.15em] uppercase transition-colors duration-300 ${
                  isActive ? "text-[#C9A24B]" : "text-[#A1A1AA] hover:text-[#F5F5F0]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-enquire-button"
            className="text-sm tracking-[0.15em] uppercase bg-[#C9A24B] text-black px-6 py-2.5 hover:bg-[#E5E4E2] transition-colors duration-300"
          >
            Enquire
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#F5F5F0]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} strokeWidth={1.4} /> : <Menu size={26} strokeWidth={1.4} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className={({ isActive }) =>
                  `text-base tracking-[0.15em] uppercase ${
                    isActive ? "text-[#C9A24B]" : "text-[#A1A1AA]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="text-sm tracking-[0.15em] uppercase bg-[#C9A24B] text-black px-6 py-3 text-center mt-2"
            >
              Enquire
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
